import React from 'react'

const Autocheckout = () => {
  return (
    <div>Autocheckout</div>
  )
}

export default Autocheckout